import React, { useState, useEffect, Fragment, useRef } from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {
  Box,
  Card,
  Grid,
  TextField,
  makeStyles,
  Container,
  Button,
  CardContent,
  Divider,
  InputLabel,
  CardHeader,
  MenuItem
} from '@material-ui/core';
import Page from 'src/components/Page';
import TablePagination from '@material-ui/core/TablePagination';
import services from '../Services';
import { trackPromise } from 'react-promise-tracker';
import { Formik } from 'formik';
import * as Yup from 'yup';
import authService from '../../../../utils/permissionAuth';
import tokenService from '../../../../utils/tokenDecoder';
import { useNavigate } from 'react-router-dom';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableContainer from '@material-ui/core/TableContainer';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import { KeyboardDatePicker } from "@material-ui/pickers";
import moment from 'moment';
import xlsx from 'json-as-xlsx';
import ReactToPrint from 'react-to-print';
import CreatePDF from './CreatePDF';
import { start } from 'nprogress';

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  },
  avatar: {
    marginRight: theme.spacing(2)
  },
  colorCancel: {
    backgroundColor: 'red'
  },
  colorRecord: {
    backgroundColor: 'green'
  }
}));

const screenCode = 'ACCOUNTPAYABLEWITHAGING';
export default function AccountsPayablewithAging(props) {
  const today = new Date();
  const previousMonth = new Date();
  previousMonth.setMonth(today.getMonth() - 1);
  const [title, setTitle] = useState('Accounts Payable With Aging Report');
  const classes = useStyles();
  const [selectedDate, setSelectedDate] = useState(previousMonth);
  const [accountsPayablDetail, setaccountsPayablDetail] = useState({
    groupID: 0,
    factoryID: 0,
    routeID: 0,
    startDate: '',
    endDate: ''
  });
  const [FactoryList, setFactoryList] = useState([]);
  const [GroupList, setGroupList] = useState([]);
  const [permissionList, setPermissions] = useState({
    isGroupFilterEnabled: false,
    isFactoryFilterEnabled: false
  });
  const navigate = useNavigate();

  const [csvHeaders, SetCsvHeaders] = useState([]);
  const [selectedSearchValues, setSelectedSearchValues] = useState({
    factoryName: '0',
    groupName: '0',
    startDate: '',
    endDate: ''
  });

  const componentRef = useRef();
  const [totalAmount, setTotalAmount] = useState([]);
  const [alertCount, setAlertCount] = useState({
    count: 0
  });
  const [reportData, setReportData] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  useEffect(() => {
    trackPromise(getPermission());
    trackPromise(getGroupsForDropdown());
    setAlertCount({
      count: 1
    });
  }, []);

  useEffect(() => {
    if (accountsPayablDetail.groupID != 0) {
      getFactoriesForDropdown();
      setAlertCount({
        count: alertCount.count + 1
      });
    }
  }, [accountsPayablDetail.groupID]);

  async function getPermission() {
    var permissions = await authService.getPermissionsByScreen(screenCode);
    var isAuthorized = permissions.find(
      p => p.permissionCode == 'VIEWACCOUNTPAYABLEWITHAGING'
    );

    if (isAuthorized === undefined) {
      navigate('/404');
    }
    var isGroupFilterEnabled = permissions.find(
      p => p.permissionCode == 'GROUPDROPDOWN'
    );
    var isFactoryFilterEnabled = permissions.find(
      p => p.permissionCode == 'FACTORYDROPDOWN'
    );

    setPermissions({
      ...permissionList,
      isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
      isFactoryFilterEnabled: isFactoryFilterEnabled !== undefined
    });

    setaccountsPayablDetail({
      ...accountsPayablDetail,
      groupID: parseInt(tokenService.getGroupIDFromToken()),
      factoryID: parseInt(tokenService.getFactoryIDFromToken())
    });
  }

  function handleChange(e) {
    const target = e.target;
    const value = target.value;
    setaccountsPayablDetail({
      ...accountsPayablDetail,
      [e.target.name]: value
    });
  }

  async function getGroupsForDropdown() {
    const groups = await services.getAllGroups();
    setGroupList(groups);
  }

  async function getFactoriesForDropdown() {
    const factories = await services.getFactoryByGroupID(
      accountsPayablDetail.groupID
    );
    setFactoryList(factories);
  }

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  async function GetDetails() {
    let total = {
      totalinvoiceAmount: 0,
      totalamount: 0,
      bucket0_30: 0,
      bucket31_60: 0,
      bucket61_90: 0,
      bucket90Plus: 0
    }

    let model = {
      groupID: parseInt(accountsPayablDetail.groupID),
      factoryID: parseInt(accountsPayablDetail.factoryID),
      startDate: (moment(accountsPayablDetail.startDate).format()).toString().split('T')[0],
      endDate: (moment(accountsPayablDetail.endDate).format()).toString().split('T')[0]
    };

    getSelectedDropdownValuesForReport(model);

    const AccountsPayableData = await services.GetAccountsPayablewithAgingDetails(model);

    const dataWithDays = AccountsPayableData.map(x => {
      const invoiceDate = new Date(x.invoiceDate);
      invoiceDate.setHours(0, 0, 0, 0);
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      const timeDifference = today.getTime() - invoiceDate.getTime();
      const daysAboveDueDate = Math.max(0, Math.floor(timeDifference / (1000 * 3600 * 24)));

      return {
        ...x,
        daysAboveDueDate: daysAboveDueDate
      };
    });

    setReportData(dataWithDays);
    setPage(0);

    dataWithDays.forEach(x => {
      const amount = parseFloat(x.amount);
      const days = x.daysAboveDueDate;

      total.totalinvoiceAmount += parseFloat(x.invoiceAmount);
      total.totalpaymentsMade += parseFloat(x.paymentsMade);
      total.totalamount += amount;

      if (days >= 0 && days <= 30) {
        total.bucket0_30 += amount;
      } else if (days >= 31 && days <= 60) {
        total.bucket31_60 += amount;
      } else if (days >= 61 && days <= 90) {
        total.bucket61_90 += amount;
      } else if (days > 90) {
        total.bucket90Plus += amount;
      }
    });

    setTotalAmount(total);
    createDataForExcel(dataWithDays);
  }

  async function createDataForExcel(array) {
    var res = [];

    if (array != null) {
      array.forEach((x, idx) => {
        const days = x.daysAboveDueDate;
        let agingBucket = '';
        let bucket0_30 = '-';
        let bucket31_60 = '-';
        let bucket61_90 = '-';
        let bucket90Plus = '-';

        if (days >= 0 && days <= 30) {
          agingBucket = '0-30 Days';
          bucket0_30 = (x.amount ?? 0).toFixed(2);
        } else if (days >= 31 && days <= 60) {
          agingBucket = '31-60 Days';
          bucket31_60 = (x.amount ?? 0).toFixed(2);
        } else if (days >= 61 && days <= 90) {
          agingBucket = '61-90 Days';
          bucket61_90 = (x.amount ?? 0).toFixed(2);
        } else if (days > 90) {
          agingBucket = '90+ Days';
          bucket90Plus = (x.amount ?? 0).toFixed(2);
        }

        res.push({
          'No': idx + 1,
          'SUPPLIER': x.supplierName,
          'INVOICE No.': x.invoice,
          'INVOICE DATE': moment(x.invoiceDate).format('M/D/YYYY'),
          'AMOUNT': (x.amount ?? 0).toFixed(2),
          'DAYS OUTSTANDING': x.daysAboveDueDate,
          'AGING BUCKET': agingBucket,
          '0-30 Days': bucket0_30,
          '31-60 Days': bucket31_60,
          '61-90 Days': bucket61_90,
          '90+ Days': bucket90Plus
        });
      });

      res.push({});
      res.push({
        'No': '',
        'SUPPLIER': 'Total',
        'INVOICE No.': '',
        'INVOICE DATE': '',
        'AMOUNT': (totalAmount.totalamount ?? 0).toFixed(2),
        'DAYS OUTSTANDING': '',
        'AGING BUCKET': '',
        '0-30 Days': totalAmount.bucket0_30 > 0 ? totalAmount.bucket0_30.toFixed(2) : '-',
        '31-60 Days': totalAmount.bucket31_60 > 0 ? totalAmount.bucket31_60.toFixed(2) : '-',
        '61-90 Days': totalAmount.bucket61_90 > 0 ? totalAmount.bucket61_90.toFixed(2) : '-',
        '90+ Days': totalAmount.bucket90Plus > 0 ? totalAmount.bucket90Plus.toFixed(2) : '-'
      });

      res.push({});
      res.push({
        'No': '',
        'SUPPLIER': "Group: " + selectedSearchValues.groupName,
        'INVOICE No.': '',
        'INVOICE DATE': '',
        'AMOUNT': '',
        'DAYS OUTSTANDING': '',
        'AGING BUCKET': '',
        '0-30 Days': '',
        '31-60 Days': '',
        '61-90 Days': '',
        '90+ Days': ''
      });
      res.push({
        'No': '',
        'SUPPLIER': "Factory: " + selectedSearchValues.factoryName,
        'INVOICE No.': '',
        'INVOICE DATE': '',
        'AMOUNT': '',
        'DAYS OUTSTANDING': '',
        'AGING BUCKET': '',
        '0-30 Days': '',
        '31-60 Days': '',
        '61-90 Days': '',
        '90+ Days': ''
      });
      res.push({
        'No': '',
        'SUPPLIER': "From: " + moment(selectedSearchValues.startDate).format('MM/DD/YYYY') + " To: " + moment(selectedSearchValues.endDate).format('MM/DD/YYYY'),
        'INVOICE No.': '',
        'INVOICE DATE': '',
        'AMOUNT': '',
        'DAYS OUTSTANDING': '',
        'AGING BUCKET': '',
        '0-30 Days': '',
        '31-60 Days': '',
        '61-90 Days': '',
        '90+ Days': ''
      });
    }

    return res;
  }

  async function createFile() {
    var file = await createDataForExcel(reportData);
    var settings = {
      sheetName: 'Accounts Payable With Aging Report',
      fileName:
        'Accounts Payable With Aging Report ' +
        selectedSearchValues.factoryName +
        ' - ' +
        selectedSearchValues.groupName +
        ' Accounts Payable With Aging Report ' +
        selectedSearchValues.startDate +
        ' - ' +
        selectedSearchValues.endDate,
      writeOptions: {}
    };

    let keys = Object.keys(file[0]);
    let tempcsvHeaders = csvHeaders;
    keys.map((sitem, i) => {
      tempcsvHeaders.push({ label: sitem, value: sitem });
    });

    let dataA = [
      {
        sheet: 'Accounts Payable Report',
        columns: tempcsvHeaders,
        content: file
      }
    ];

    xlsx(dataA, settings);
  }

  function generateDropDownMenu(data) {
    let items = [];
    if (data != null) {
      for (const [key, value] of Object.entries(data)) {
        items.push(
          <MenuItem key={key} value={key}>
            {value}
          </MenuItem>
        );
      }
    }
    return items;
  }

  function getSelectedDropdownValuesForReport(searchForm) {
    setSelectedSearchValues({
      ...selectedSearchValues,
      factoryName: FactoryList[searchForm.factoryID],
      groupName: GroupList[searchForm.groupID],
      startDate: searchForm.startDate,
      endDate: searchForm.endDate
    });
  }

  function cardTitle(titleName) {
    return (
      <Grid container spacing={1}>
        <Grid item md={10} xs={12}>
          {titleName}
        </Grid>
      </Grid>
    );
  }

  return (
    <Fragment>
      <style>
        {`
        @media print {
          body {
            background-color: white !important;
          }
          * {
            background-color: white !important;
          }
        }
      `}
      </style>
      <Page className={classes.root} title={title}>
        <Container maxWidth={false}>
          <Formik
            initialValues={{
              groupID: accountsPayablDetail.groupID,
              factoryID: accountsPayablDetail.factoryID,
              startDate: accountsPayablDetail.startDate,
              endDate: accountsPayablDetail.endDate
            }}
            validationSchema={Yup.object().shape({
              groupID: Yup.number()
                .required('Group is required')
                .min('1', 'Group is required'),
              factoryID: Yup.number()
                .required('Factory is required')
                .min('1', 'Factory is required'),
              startDate: Yup.date()
                .required('From Date is required')
                .min(1, 'From Date is required'),
              endDate: Yup.date()
                .required('To Date is required')
                .min(1, 'To Date is required')
            })}
            enableReinitialize
          >
            {({ errors, handleBlur, handleSubmit, touched }) => (
              <form onSubmit={handleSubmit}>
                <Box mt={0}>
                  <Card>
                    <CardHeader title={cardTitle(title)} />
                    <PerfectScrollbar>
                      <Divider />
                      <CardContent>
                        <Grid container spacing={3}>
                          <Grid item md={4} xs={8}>
                            <InputLabel shrink id="groupID">
                              Group *
                            </InputLabel>
                            <TextField
                              select
                              error={Boolean(touched.groupID && errors.groupID)}
                              fullWidth
                              helperText={touched.groupID && errors.groupID}
                              name="groupID"
                              onBlur={handleBlur}
                              onChange={e => handleChange(e)}
                              value={accountsPayablDetail.groupID}
                              variant="outlined"
                              id="groupID"
                              disabled={!permissionList.isGroupFilterEnabled}
                              size="small"
                            >
                              <MenuItem value="0">--Select Group--</MenuItem>
                              {generateDropDownMenu(GroupList)}
                            </TextField>
                          </Grid>

                          <Grid item md={4} xs={8}>
                            <InputLabel shrink id="factoryID">
                              Factory *
                            </InputLabel>
                            <TextField
                              select
                              error={Boolean(
                                touched.factoryID && errors.factoryID
                              )}
                              fullWidth
                              helperText={touched.factoryID && errors.factoryID}
                              name="factoryID"
                              onBlur={handleBlur}
                              onChange={e => handleChange(e)}
                              value={accountsPayablDetail.factoryID}
                              variant="outlined"
                              id="factoryID"
                              disabled={!permissionList.isFactoryFilterEnabled}
                              size="small"
                            >
                              <MenuItem value="0">--Select Factory--</MenuItem>
                              {generateDropDownMenu(FactoryList)}
                            </TextField>
                          </Grid>
                          <Grid item md={3} xs={8}>
                            <InputLabel shrink id="startDate">
                              From Date *
                            </InputLabel>
                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                              <KeyboardDatePicker
                                error={Boolean(touched.startDate && errors.startDate)}
                                helperText={touched.startDate && errors.startDate}
                                autoOk
                                fullWidth
                                variant="inline"
                                format="dd/MM/yyyy"
                                inputVariant="outlined"
                                id="startDate"
                                size='small'
                                name="startDate"
                                value={accountsPayablDetail.startDate}
                                onChange={date => setaccountsPayablDetail({
                                  ...accountsPayablDetail,
                                  startDate: date
                                })}
                                KeyboardButtonProps={{
                                  'aria-label': 'change startDate',
                                }}
                              />
                            </MuiPickersUtilsProvider>
                          </Grid>
                          <Grid item md={3} xs={8}>
                            <InputLabel shrink id="endDate">
                              To Date *
                            </InputLabel>
                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                              <KeyboardDatePicker
                                error={Boolean(touched.endDate && errors.endDate)}
                                helperText={touched.endDate && errors.endDate}
                                autoOk
                                fullWidth
                                variant="inline"
                                format="dd/MM/yyyy"
                                inputVariant="outlined"
                                id="endDate"
                                size='small'
                                name="endDate"
                                value={accountsPayablDetail.endDate}
                                onChange={date => setaccountsPayablDetail({
                                  ...accountsPayablDetail,
                                  endDate: date
                                })}
                                KeyboardButtonProps={{
                                  'aria-label': 'change endDate',
                                }}
                              />
                            </MuiPickersUtilsProvider>
                          </Grid>
                        </Grid>
                        <Grid container justify="flex-end">
                          <Box pt={2}>
                            <Button
                              color="primary"
                              variant="contained"
                              type='submit'
                              onClick={() => trackPromise(GetDetails())}
                            >
                              Search
                            </Button>
                          </Box>
                        </Grid>
                      </CardContent>
                      {reportData.length > 0 ? (
                        <Box minWidth={1050}>
                          <TableContainer style={{ marginLeft: '2px' }}>
                            <Table aria-label="caption table">
                              <TableHead>
                                <TableRow>
                                  <TableCell align="right" style={{ fontWeight: "bold", border: "1px solid black" }}>No</TableCell>
                                  <TableCell align="left" style={{ fontWeight: "bold", border: "1px solid black" }}>SUPPLIER</TableCell>
                                  <TableCell align="left" style={{ fontWeight: "bold", border: "1px solid black" }}>INVOICE No.</TableCell>
                                  <TableCell align="center" style={{ fontWeight: "bold", border: "1px solid black" }}>INVOICE DATE</TableCell>
                                  <TableCell align="right" style={{ fontWeight: "bold", border: "1px solid black" }}>AMOUNT</TableCell>
                                  <TableCell align="right" style={{ fontWeight: "bold", border: "1px solid black" }}>DAYS OUTSTANDING</TableCell>
                                  <TableCell align="left" style={{ fontWeight: "bold", border: "1px solid black" }}>AGING BUCKET</TableCell>
                                  <TableCell align="right" style={{ fontWeight: "bold", border: "1px solid black" }}>0-30 Days</TableCell>
                                  <TableCell align="right" style={{ fontWeight: "bold", border: "1px solid black" }}>31-60 Days</TableCell>
                                  <TableCell align="right" style={{ fontWeight: "bold", border: "1px solid black" }}>61-90 Days</TableCell>
                                  <TableCell align="right" style={{ fontWeight: "bold", border: "1px solid black" }}>90+ Days</TableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {reportData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((data, index) => {
                                  const days = data.daysAboveDueDate;
                                  let agingBucket = '';
                                  let bucket0_30 = '-';
                                  let bucket31_60 = '-';
                                  let bucket61_90 = '-';
                                  let bucket90Plus = '-';

                                  if (days >= 0 && days <= 30) {
                                    agingBucket = '0-30 Days';
                                    bucket0_30 = data.amount.toFixed(2);
                                  } else if (days >= 31 && days <= 60) {
                                    agingBucket = '31-60 Days';
                                    bucket31_60 = data.amount.toFixed(2);
                                  } else if (days >= 61 && days <= 90) {
                                    agingBucket = '61-90 Days';
                                    bucket61_90 = data.amount.toFixed(2);
                                  } else if (days > 90) {
                                    agingBucket = '90+ Days';
                                    bucket90Plus = data.amount.toFixed(2);
                                  }

                                  return (
                                    <TableRow key={index}>
                                      <TableCell align={'right'} style={{ borderBottom: "none", border: "1px solid black" }}>
                                        {page * rowsPerPage + index + 1}
                                      </TableCell>
                                      <TableCell align={'left'} style={{ borderBottom: "none", border: "1px solid black" }}>
                                        {data.supplierName}
                                      </TableCell>
                                      <TableCell align={'left'} style={{ borderBottom: "none", border: "1px solid black" }}>
                                        {data.invoice}
                                      </TableCell>
                                      <TableCell align={'center'} style={{ borderBottom: "none", border: "1px solid black" }}>
                                        {moment(data.invoiceDate).format('M/D/YYYY')}
                                      </TableCell>
                                      <TableCell align={'right'} style={{ borderBottom: "none", border: "1px solid black" }}>
                                        {data.amount.toFixed(2)}
                                      </TableCell>
                                      <TableCell align={'right'} style={{ borderBottom: "none", border: "1px solid black" }}>
                                        {data.daysAboveDueDate}
                                      </TableCell>
                                      <TableCell align={'left'} style={{ borderBottom: "none", border: "1px solid black" }}>
                                        {agingBucket}
                                      </TableCell>
                                      <TableCell align={'right'} style={{ borderBottom: "none", border: "1px solid black" }}>
                                        {bucket0_30}
                                      </TableCell>
                                      <TableCell align={'right'} style={{ borderBottom: "none", border: "1px solid black" }}>
                                        {bucket31_60}
                                      </TableCell>
                                      <TableCell align={'right'} style={{ borderBottom: "none", border: "1px solid black" }}>
                                        {bucket61_90}
                                      </TableCell>
                                      <TableCell align={'right'} style={{ borderBottom: "none", border: "1px solid black" }}>
                                        {bucket90Plus}
                                      </TableCell>
                                    </TableRow>
                                  );
                                })}
                                <TableRow>
                                  <TableCell align={'left'} colSpan={4} style={{ borderBottom: "none", border: "1px solid black" }}>
                                    <b>Total</b>
                                  </TableCell>
                                  <TableCell align={'right'} style={{ borderBottom: "none", border: "1px solid black" }}>
                                    <b>{parseFloat(totalAmount.totalamount).toFixed(2)}</b>
                                  </TableCell>
                                  <TableCell align={'center'} colSpan={2} style={{ borderBottom: "none", border: "1px solid black" }}>
                                  </TableCell>
                                  <TableCell align={'right'} style={{ borderBottom: "none", border: "1px solid black" }}>
                                    <b>{totalAmount.bucket0_30 > 0 ? totalAmount.bucket0_30.toFixed(2) : '-'}</b>
                                  </TableCell>
                                  <TableCell align={'right'} style={{ borderBottom: "none", border: "1px solid black" }}>
                                    <b>{totalAmount.bucket31_60 > 0 ? totalAmount.bucket31_60.toFixed(2) : '-'}</b>
                                  </TableCell>
                                  <TableCell align={'right'} style={{ borderBottom: "none", border: "1px solid black" }}>
                                    <b>{totalAmount.bucket61_90 > 0 ? totalAmount.bucket61_90.toFixed(2) : '-'}</b>
                                  </TableCell>
                                  <TableCell align={'right'} style={{ borderBottom: "none", border: "1px solid black" }}>
                                    <b>{totalAmount.bucket90Plus > 0 ? totalAmount.bucket90Plus.toFixed(2) : '-'}</b>
                                  </TableCell>
                                </TableRow>
                              </TableBody>
                            </Table>
                          </TableContainer>
                          <TablePagination
                            rowsPerPageOptions={[10, 25, 50, 100]}
                            component="div"
                            count={reportData.length}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            onChangePage={handleChangePage}
                            onChangeRowsPerPage={handleChangeRowsPerPage}
                          />
                        </Box>
                      ) : null}
                      {reportData.length > 0 ? (
                        <Box display="flex" justifyContent="flex-end" p={2}>
                          <Button
                            color="primary"
                            id="btnRecord"
                            type="submit"
                            variant="contained"
                            style={{ marginRight: '1rem' }}
                            className={classes.colorRecord}
                            onClick={createFile}
                            size="small"
                          >
                            EXCEL
                          </Button>
                          <div>&nbsp;</div>

                          <ReactToPrint
                            documentTitle={'Accounts Payable With Aging Report ' +
                              selectedSearchValues.factoryName +
                              ' - ' +
                              selectedSearchValues.groupName +
                              ' Accounts Payable With Aging Report ' +
                              selectedSearchValues.startDate +
                              ' - ' +
                              selectedSearchValues.endDate}
                            trigger={() => (
                              <Button
                                color="primary"
                                id="btnRecord"
                                type="submit"
                                variant="contained"
                                style={{ marginRight: '1rem' }}
                                className={classes.colorCancel}
                                size="small"
                              >
                                PDF
                              </Button>
                            )}
                            content={() => componentRef.current}
                          />
                          <div hidden={true} style={{ backgroundColor: 'white' }}>
                            <CreatePDF
                              ref={componentRef}
                              searchData={selectedSearchValues}
                              searchDate={accountsPayablDetail}
                              reportData={reportData}
                              total={totalAmount}
                            />
                          </div>
                        </Box>
                      ) : null};
                    </PerfectScrollbar>
                  </Card>
                </Box>
              </form>
            )}
          </Formik>
        </Container>
      </Page>
    </Fragment>
  );
}
